import * as React from 'react';
import { Body } from 'vet-bones/design-system/components';

import { DataSourceIcon } from 'src/components/resourceDialog/DataSourceIcon';
import { currentFeatureVersionSelector } from 'src/selectors/currentFeatureVersion';
import { DataSource } from 'src/store/state/dataSources';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

import styles from 'src/containers/ProjectNewResourceDialog/components/dataSourceHeaderCard.module.scss';

export type DataSourceHeaderCardProps = {
  dataSource: DataSource;
  dataSourceType: string;
};

export const DataSourceHeaderCard: React.VFC<DataSourceHeaderCardProps> = ({
  dataSource,
  dataSourceType,
}) => {
  const stardogVersion = useReduxSelector(currentFeatureVersionSelector);

  return (
    <div className={styles.dataSourceHeaderCard}>
      <div className={styles.iconWrapper}>
        <DataSourceIcon
          dataSourceType={dataSourceType}
          size={32}
          stardogVersion={stardogVersion}
        />
      </div>
      <Body size="md" weight="semibold">
        {dataSource.id}
      </Body>
    </div>
  );
};
